import { defineMessages } from 'react-intl';

const messages = defineMessages({
  info: {
    id: 'modules.CatalogV2.pages.Product.components.VariantsTable.info',
    defaultMessage:
      'Confira as opções deste produto que os lojistas podem solicitar quando compram na Inventa:',
  },
  skuTableHeader: {
    id: 'modules.CatalogV2.pages.Product.components.VariantsTable.skuTableHeader',
    defaultMessage: 'SKU',
  },
  nameTableHeader: {
    id: 'modules.CatalogV2.pages.Product.components.VariantsTable.nameTableHeader',
    defaultMessage: 'Variante',
  },
  priceTableHeader: {
    id: 'modules.CatalogV2.pages.Product.components.VariantsTable.priceTableHeader',
    defaultMessage: 'Valor',
  },
  inStockTableHeader: {
    id: 'modules.CatalogV2.pages.Product.components.VariantsTable.inStockTableHeader',
    defaultMessage: 'Em estoque',
  },
});

export default messages;
